var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section", staticStyle: { "min-width": "1200px" } },
    [
      _c(
        "div",
        { staticClass: "form-card-wrapper", staticStyle: { width: "100%" } },
        [
          _c("div", { staticClass: "section form-row" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.DoorToDoorLoading")) + " "),
              _c(
                "span",
                {
                  staticStyle: {
                    color: "red",
                    "font-weight": "lighter",
                    margin: "30px"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.SaveBusinessBeforeEnterMultiGate"))
                  )
                ]
              )
            ]),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _vm.showSecondSync
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.syncToDischargingTruckingInfo }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.SecondarySynchronization")
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.job.multiplePickups,
                        expression: "job.multiplePickups"
                      }
                    ]
                  },
                  [
                    _c("cargo-ag-grid", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "1",
                        "grid-options": _vm.top.gridOptions,
                        "grid-params": _vm.top.gridParams,
                        "column-defs": _vm.top.columnDefs,
                        "row-data": _vm.trucking
                      },
                      on: {
                        "update:gridParams": function($event) {
                          return _vm.$set(_vm.top, "gridParams", $event)
                        },
                        "update:grid-params": function($event) {
                          return _vm.$set(_vm.top, "gridParams", $event)
                        },
                        gridReady: function(params) {
                          _vm.topgridApi = params.api
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm.job.multiplePickups
                  ? _c(
                      "div",
                      {
                        staticClass: "app-main-inner-row operations",
                        staticStyle: { padding: "5px 0" }
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.cooperateEdit,
                                expression: "cooperateEdit"
                              }
                            ],
                            staticClass: "triggers"
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "2",
                                      type: "primary",
                                      disabled: _vm.readonly
                                    },
                                    on: { click: _vm.copyNewHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.copyAndAddPoItems")
                                      ) + " "
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "3",
                                      type: "primary",
                                      disabled: _vm.readonly
                                    },
                                    on: { click: _vm.addHandler }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "4",
                                      disabled: !_vm.btnEnable.btDel,
                                      type: "danger"
                                    },
                                    on: { click: _vm.delHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.Delete")) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.job.multiplePickups ? _c("el-divider") : _vm._e(),
                _c(
                  "el-form",
                  {
                    staticClass: "inline-form",
                    attrs: {
                      inline: true,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { disabled: _vm.readonly } },
                      [
                        _c(
                          "template",
                          { slot: "label" },
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: { no: "5" },
                                on: { change: _vm.multiPickupsChangeHandler },
                                model: {
                                  value: _vm.job.multiplePickups,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "multiplePickups", $$v)
                                  },
                                  expression: "job.multiplePickups"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.MultiDoors")) + " "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { width: "auto" },
                            attrs: {
                              no: "loadingPortService",
                              disabled: _vm.readonly
                            },
                            on: { change: _vm.onLoadingPortServiceChange },
                            model: {
                              value: _vm.truckingInfo.loadingPortService,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.truckingInfo,
                                  "loadingPortService",
                                  $$v
                                )
                              },
                              expression: "truckingInfo.loadingPortService"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("CargoMsg.Cargo_PortOfLoading")) +
                                _vm._s(_vm.isZh ? "" : " ") +
                                _vm._s(_vm.$t("SeaExport.Service")) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { width: "auto" },
                            attrs: {
                              no: "dischargingPortService",
                              disabled: _vm.readonly
                            },
                            on: { change: _vm.onDischargingPortServiceChange },
                            model: {
                              value: _vm.truckingInfo.dischargingPortService,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.truckingInfo,
                                  "dischargingPortService",
                                  $$v
                                )
                              },
                              expression: "truckingInfo.dischargingPortService"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_PortOfDischarge")
                                ) +
                                _vm._s(_vm.isZh ? "" : " ") +
                                _vm._s(_vm.$t("SeaExport.Service")) +
                                " "
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    staticClass: "inline-form",
                    attrs: {
                      inline: true,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { disabled: _vm.readonly } },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "119px", "margin-left": "2px" },
                          attrs: {
                            no: "6",
                            value: _vm.truckingInfo.quantity || undefined,
                            disabled: _vm.readonly,
                            min: 0,
                            max: 99999,
                            precision: 0,
                            "controls-position": "right"
                          },
                          on: {
                            input: function(val) {
                              _vm.truckingInfo.quantity = val
                            }
                          }
                        }),
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("SeaExport.Weight")))
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "119px" },
                          attrs: {
                            no: "7",
                            value: _vm.truckingInfo.weight || undefined,
                            disabled: _vm.readonly,
                            min: 0,
                            max: 99999,
                            precision: 3,
                            "controls-position": "right"
                          },
                          on: {
                            input: function(val) {
                              _vm.truckingInfo.weight = val
                            }
                          }
                        }),
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "119px" },
                          attrs: {
                            no: "8",
                            value: _vm.truckingInfo.cubage || undefined,
                            disabled: _vm.readonly,
                            min: 0,
                            max: 99999,
                            precision: 3,
                            "controls-position": "right"
                          },
                          on: {
                            input: function(val) {
                              _vm.truckingInfo.cubage = val
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm.job.multiplePickups
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: "S/O No.",
                              "label-width": _vm.isZh ? "" : "120px"
                            }
                          },
                          [
                            _c("so-no-selector", {
                              staticStyle: { width: "400px" },
                              attrs: {
                                no: "9",
                                "so-no": _vm.soNo,
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.truckingInfo.soNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "soNo", $$v)
                                },
                                expression: "truckingInfo.soNo"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "trucking-form" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          "label-width": _vm.isZh ? "100px" : "145px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.HaulageCompany") }
                          },
                          [
                            _c("cargo-company-select", {
                              staticStyle: {
                                width: "400px",
                                display: "inline-block"
                              },
                              attrs: {
                                no: "10",
                                disabled: _vm.readonly,
                                "method-params": {
                                  truckCmp: true,
                                  active: true
                                },
                                "default-value":
                                  _vm.truckingInfo.carryingCmp || ""
                              },
                              on: {
                                change: function(p) {
                                  _vm.truckingInfo.carryingCmp = p.value || 0
                                  _vm.carryingCmpChangeHandler()
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("SeaExport.HaulageContactPerson")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "400px" },
                                attrs: {
                                  no: "11",
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                  "allow-create": "",
                                  "default-first-option": "",
                                  clearable: "",
                                  filterable: ""
                                },
                                on: {
                                  change: _vm.carryingContactsChangeHandler
                                },
                                model: {
                                  value: _vm.truckingInfo.driver,
                                  callback: function($$v) {
                                    _vm.$set(_vm.truckingInfo, "driver", $$v)
                                  },
                                  expression: "truckingInfo.driver"
                                }
                              },
                              _vm._l(_vm.carryingContacts, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.contactPerson,
                                    value: item.contactPerson
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.truckingInfo.loadingPortService
                                ? _vm.$t(
                                    "SeaExport.CargosExpectedArrivalDatePacking"
                                  )
                                : _vm.$t("CargoMsg.EstimatedDeliveryDate")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "400px" },
                              attrs: {
                                no: "12",
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm",
                                placeholder: " "
                              },
                              model: {
                                value: _vm.truckingInfo.loadingDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "loadingDate", $$v)
                                },
                                expression: "truckingInfo.loadingDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("Warehouse.Driver"),
                              disabled: _vm.txtEditEable
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "400px" },
                                attrs: {
                                  no: "12",
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                  "allow-create": true,
                                  clearable: true,
                                  filterable: ""
                                },
                                on: {
                                  change: _vm.driverInfomationsChangeHandler
                                },
                                model: {
                                  value: _vm.truckingInfo.driverName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.truckingInfo,
                                      "driverName",
                                      $$v
                                    )
                                  },
                                  expression: "truckingInfo.driverName"
                                }
                              },
                              _vm._l(_vm.driverInfomations, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.driverName,
                                    value: item.driverName
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.travelTime") }
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "105px" },
                              attrs: {
                                no: "13",
                                min: 0,
                                "controls-position": "right"
                              },
                              model: {
                                value: _vm.truckingInfo.travelHour,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "travelHour", $$v)
                                },
                                expression: "truckingInfo.travelHour"
                              }
                            }),
                            _c("span", { staticStyle: { margin: "10px" } }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.Hour")))
                            ]),
                            _c("el-input-number", {
                              staticStyle: { width: "100px" },
                              attrs: {
                                no: "14",
                                min: 0,
                                "controls-position": "right"
                              },
                              model: {
                                value: _vm.truckingInfo.travelMinute,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.truckingInfo,
                                    "travelMinute",
                                    $$v
                                  )
                                },
                                expression: "truckingInfo.travelMinute"
                              }
                            }),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("SeaExport.Minute")))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("SeaExport.DoorContactPerson")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "400px" },
                              attrs: { no: "15" },
                              model: {
                                value: _vm.truckingInfo.doorMan,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "doorMan", $$v)
                                },
                                expression: "truckingInfo.doorMan"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.DoorAddress") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "400px" },
                              attrs: {
                                no: "16",
                                type: "textarea",
                                rows: 3,
                                "filter-chars": false
                              },
                              on: { change: _vm.refreshGrid },
                              model: {
                                value: _vm.truckingInfo.doorAddr,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "doorAddr", $$v)
                                },
                                expression: "truckingInfo.doorAddr"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.ZIP") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "400px" },
                              attrs: { no: "zipCode" },
                              model: {
                                value: _vm.truckingInfo.zipCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "zipCode", $$v)
                                },
                                expression: "truckingInfo.zipCode"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { "label-width": "0" }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "custom",
                                    attrs: {
                                      label: _vm.$t("Pricing.BelongingCity")
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "160px" },
                                      attrs: {
                                        no: "17",
                                        disabled: _vm.readonly,
                                        "tag-name":
                                          _vm.$store.getters.language === "zh"
                                            ? "chineseName"
                                            : "englishName",
                                        "tag-value": "code",
                                        cache: false,
                                        filterable: "",
                                        "default-value":
                                          _vm.truckingInfo.cityCode,
                                        "static-options": _vm.cityList,
                                        placeholder: _vm.$t(
                                          "SeaExport.PleaseSelect"
                                        )
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          return (_vm.truckingInfo.cityCode =
                                            p.value)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form",
                                  {
                                    attrs: {
                                      "label-width": "100px",
                                      "label-position": "left"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "custom",
                                        attrs: {
                                          label: _vm.$t("Warehouse.PalletSum")
                                        }
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "140px" },
                                          attrs: {
                                            no: "18",
                                            value: _vm.truckingInfo.palletSum,
                                            disabled: _vm.readonly,
                                            min: 0,
                                            max: 999999999999,
                                            precision: 0,
                                            controls: false
                                          },
                                          on: {
                                            input: function(val) {
                                              _vm.truckingInfo.palletSum =
                                                val || 0
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "PO" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "400px" },
                              attrs: {
                                no: "po",
                                disabled: _vm.readonly,
                                "filter-chars": false,
                                type: "textarea",
                                rows: 3
                              },
                              model: {
                                value: _vm.truckingInfo.po,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "po", $$v)
                                },
                                expression: "truckingInfo.po"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": _vm.isZh ? "100px" : "120px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.HaulageNo") }
                          },
                          [
                            _c("el-input", {
                              style: { width: _vm.isZh ? "160px" : "155px" },
                              attrs: { no: "19", disabled: _vm.readonly },
                              on: { change: _vm.refreshGrid },
                              model: {
                                value: _vm.truckingInfo.truckOrderNo,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.truckingInfo,
                                    "truckOrderNo",
                                    $$v
                                  )
                                },
                                expression: "truckingInfo.truckOrderNo"
                              }
                            }),
                            _c(
                              "label",
                              { style: { margin: _vm.isZh ? "" : "0 1px" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.HaulageCharge"))
                                )
                              ]
                            ),
                            _c("el-input-number", {
                              staticStyle: { width: "120px" },
                              attrs: {
                                no: "20",
                                disabled: _vm.readonly,
                                min: 0,
                                max: 999999999999,
                                precision: 2,
                                "controls-position": "right"
                              },
                              on: { change: _vm.truckingFeeCharge },
                              model: {
                                value: _vm.truckingInfo.truckingFee,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "truckingFee", $$v)
                                },
                                expression: "truckingInfo.truckingFee"
                              }
                            }),
                            _c("span", { staticClass: "currency" }, [
                              _vm._v(_vm._s(_vm.localCurrency))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.Tel") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "400px" },
                              attrs: { no: "21", disabled: _vm.readonly },
                              model: {
                                value: _vm.truckingInfo.driverTel,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "driverTel", $$v)
                                },
                                expression: "truckingInfo.driverTel"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.truckingInfo.loadingPortService
                                ? _vm.$t("SeaExport.CargoActArrivalDatePacking")
                                : _vm.$t("CargoMsg.ActualDeliveryDate")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "400px" },
                              attrs: {
                                no: "actLoadingDate",
                                disabled: _vm.readonly,
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm"
                              },
                              model: {
                                value: _vm.truckingInfo.actLoadingDate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.truckingInfo,
                                    "actLoadingDate",
                                    $$v
                                  )
                                },
                                expression: "truckingInfo.actLoadingDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.PlateNumber") }
                          },
                          [
                            _vm.isEdit
                              ? _c("el-input", {
                                  style: {
                                    width: _vm.isZh ? "280px" : "215px"
                                  },
                                  attrs: { no: "22", disabled: _vm.readonly },
                                  model: {
                                    value: _vm.truckingInfo.plateNumber,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "plateNumber",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.plateNumber"
                                  }
                                })
                              : _vm._e(),
                            _vm.readonly
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "plate_number",
                                    style: {
                                      width: _vm.isZh ? "280px" : "215px"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.truckingInfo.plateNumber))]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("Warehouse.DriverPhone"),
                              disabled: _vm.txtEditEable
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "400px" },
                              attrs: { no: "45", disabled: _vm.readonly },
                              model: {
                                value: _vm.truckingInfo.driverPhone,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "driverPhone", $$v)
                                },
                                expression: "truckingInfo.driverPhone"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.Door") }
                          },
                          [
                            _c("cargo-repeat-value-select", {
                              staticStyle: { width: "400px" },
                              attrs: {
                                no: "24",
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                filterable: "",
                                "allow-create": true,
                                clearable: "",
                                options: _vm.doorList,
                                "label-field": "name",
                                "value-field": "name",
                                "unique-field": "uuid",
                                disabled: _vm.readonly,
                                "match-of-repeat-value": _vm.matchOfRepeatDoor
                              },
                              on: { change: _vm.doorsChangeHandler },
                              model: {
                                value: _vm.truckingInfo.doorName,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "doorName", $$v)
                                },
                                expression: "truckingInfo.doorName"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.$checkPermission([
                                      "button_Common_AddSite"
                                    ]),
                                    expression:
                                      "$checkPermission(['button_Common_AddSite'])"
                                  }
                                ],
                                staticClass: "vehicle-btn",
                                attrs: {
                                  no: "addDoor",
                                  disabled: !_vm.isEdit,
                                  type: "primary",
                                  size: "mini"
                                },
                                on: { click: _vm.addDoor }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Partners.doorInformation"))
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.Tel") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "400px" },
                              attrs: { no: "25", disabled: _vm.readonly },
                              model: {
                                value: _vm.truckingInfo.doorManTel,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "doorManTel", $$v)
                                },
                                expression: "truckingInfo.doorManTel"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.AdditionalNotes")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "400px" },
                              attrs: {
                                no: "26",
                                disabled: _vm.readonly,
                                "filter-chars": false,
                                type: "textarea",
                                rows: 3
                              },
                              on: { change: _vm.refreshGrid },
                              model: {
                                value: _vm.truckingInfo.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "remarks", $$v)
                                },
                                expression: "truckingInfo.remarks"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.truckingInfo.dischargingPortService
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.DischargingWay")
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "400px" },
                                    attrs: {
                                      value: _vm.truckingInfo.dischargingWay
                                        ? _vm.truckingInfo.dischargingWay.split(
                                            ","
                                          )
                                        : [],
                                      no: "dischargingWay",
                                      disabled: _vm.readonly,
                                      multiple: ""
                                    },
                                    on: {
                                      input: function(value) {
                                        _vm.truckingInfo.dischargingWay = value.join(
                                          ","
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: "DROP" }
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "LIVE UNLOAD" }
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "EXCHANGE PALLETS" }
                                    }),
                                    _vm.job.lob === "SI"
                                      ? _c("el-option", {
                                          attrs: { value: "拼车" }
                                        })
                                      : _vm._e(),
                                    _vm.job.lob === "SI"
                                      ? _c("el-option", {
                                          attrs: { value: "整车" }
                                        })
                                      : _vm._e(),
                                    _vm.job.lob === "SI"
                                      ? _c("el-option", {
                                          attrs: { value: "快递" }
                                        })
                                      : _vm._e(),
                                    _vm.job.lob === "SI"
                                      ? _c("el-option", {
                                          attrs: { value: "空运" }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.truckingInfo.dischargingPortService
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.LatestDeliveryDate")
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    no: "actDeliveryDate",
                                    disabled: _vm.readonly,
                                    type: "datetime",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    format: "yyyy-MM-dd HH:mm"
                                  },
                                  model: {
                                    value: _vm.truckingInfo.actDeliveryDate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.truckingInfo,
                                        "actDeliveryDate",
                                        $$v
                                      )
                                    },
                                    expression: "truckingInfo.actDeliveryDate"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("Partners.IdentityCard") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "400px" },
                              attrs: { no: "60", disabled: _vm.readonly },
                              model: {
                                value: _vm.truckingInfo.driverIdCard,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.truckingInfo,
                                    "driverIdCard",
                                    $$v
                                  )
                                },
                                expression: "truckingInfo.driverIdCard"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.job.lob === "SE" ||
                _vm.job.lob === "SI" ||
                _vm.job.lob === "RE" ||
                _vm.job.lob === "RI"
                  ? _c(
                      "div",
                      {
                        staticClass: "app-main-inner-row operations",
                        staticStyle: {
                          "margin-bottom": "5px",
                          "padding-left": "0"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.cooperateEdit,
                                expression: "cooperateEdit"
                              }
                            ],
                            staticClass: "triggers"
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "27",
                                      type: "primary",
                                      disabled: !_vm.btnEnable.grpTruckOrderBtns
                                    },
                                    on: { click: _vm.linkUsageClickHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.AddPackingInfo")
                                      ) + " "
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "28",
                                      type: "danger",
                                      disabled: !_vm.btnEnable.grpTruckOrderBtns
                                    },
                                    on: { click: _vm.delLinkUsageClickHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.RemovePackingInfo")
                                      ) + " "
                                    )
                                  ]
                                ),
                                !_vm.btnEnable.grpTruckOrderBtns
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "29",
                                          type: "primary",
                                          disabled: !_vm.btnEnable
                                            .grpTruckOrderBtns
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.command1) + " ")]
                                    )
                                  : _vm._e(),
                                _vm.btnEnable.grpTruckOrderBtns
                                  ? _c(
                                      "el-dropdown",
                                      {
                                        staticStyle: { "margin-left": "5px" },
                                        attrs: {
                                          no: "30",
                                          "split-button": "",
                                          type: "primary",
                                          disabled: !_vm.btnEnable
                                            .grpTruckOrderBtns
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.btnConnectedTruckClickHandler()
                                          },
                                          command: function(p) {
                                            _vm.command1 = p
                                            _vm.btnConnectedTruckClickHandler()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.command1) + " "
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: {
                                              slot: "dropdown",
                                              disabled: !_vm.btnEnable
                                                .grpTruckOrderBtns
                                            },
                                            slot: "dropdown"
                                          },
                                          [
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled: !_vm.btnEnable
                                                    .grpTruckOrderBtns,
                                                  command: _vm.$t(
                                                    "SeaExport.DispatchTuckOrder"
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SeaExport.DispatchTuckOrder"
                                                    )
                                                  ) + " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled: !_vm.btnEnable
                                                    .grpTruckOrderBtns,
                                                  command: _vm.$t(
                                                    "SeaExport.ModifyTuckOrder"
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SeaExport.ModifyTuckOrder"
                                                    )
                                                  ) + " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled: !_vm.btnEnable
                                                    .grpTruckOrderBtns,
                                                  command: _vm.$t(
                                                    "SeaExport.RevokeTuckOrder"
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SeaExport.RevokeTuckOrder"
                                                    )
                                                  ) + " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled: !_vm.btnEnable
                                                    .grpTruckOrderBtns,
                                                  command: _vm.$t(
                                                    "SeaExport.SearchTuckOrder"
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SeaExport.SearchTuckOrder"
                                                    )
                                                  ) + " "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: !_vm.btnEnable
                                        .grpTruckOrderBtns,
                                      type: "primary"
                                    },
                                    on: {
                                      click: _vm.showTuckOrderLogClickHandler
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.ShowTuckOrderLog")
                                      ) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.job.lob === "SE" ||
                _vm.job.lob === "SI" ||
                _vm.job.lob === "RE" ||
                _vm.job.lob === "RI"
                  ? _c(
                      "div",
                      { staticStyle: { "flex-grow": "1" } },
                      [
                        _vm.gridVisible.dgUsage
                          ? _c("cargo-ag-grid", {
                              staticStyle: { width: "100%", height: "350px" },
                              attrs: {
                                "config-module": "130005",
                                no: "31",
                                "grid-options": _vm.gridOptions,
                                "grid-params": _vm.gridParams,
                                "column-defs": _vm.columnDefs,
                                "row-data": _vm.usages
                              },
                              on: {
                                "update:gridParams": function($event) {
                                  _vm.gridParams = $event
                                },
                                "update:grid-params": function($event) {
                                  _vm.gridParams = $event
                                },
                                gridReady: function(params) {
                                  return (_vm.gridApi = params.api)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm.gridVisible.dgUsageG7
                          ? _c("cargo-ag-grid", {
                              staticStyle: { width: "100%", height: "350px" },
                              attrs: {
                                "config-module": "130006",
                                no: "32",
                                "grid-options": _vm.gridOptions,
                                "grid-params": _vm.gridParams,
                                "column-defs": _vm.columnDefsG7,
                                "row-data": _vm.usages
                              },
                              on: {
                                "update:gridParams": function($event) {
                                  _vm.gridParams = $event
                                },
                                "update:grid-params": function($event) {
                                  _vm.gridParams = $event
                                },
                                gridReady: function(params) {
                                  return (_vm.gridApi = params.api)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      ),
      _c("trucking-container-usage-link-dialog", {
        attrs: {
          visible: _vm.containerUsageDialog.visible,
          "job-uuid": _vm.job.uuid,
          "trucking-info-uuid": _vm.truckingInfo.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.containerUsageDialog, "visible", $event)
          },
          selectContainerUsageHandler: _vm.selectContainerUsageHandler
        }
      }),
      _c("tuck-order-log-dialog", {
        attrs: {
          visible: _vm.truckOrderLogDialog.visible,
          "row-data": _vm.truckOrderLogDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.truckOrderLogDialog, "visible", $event)
          }
        }
      }),
      _c("error-log-dialog", {
        attrs: {
          visible: _vm.errorLogDialog.visible,
          "row-data": _vm.errorLogDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.errorLogDialog, "visible", $event)
          }
        }
      }),
      _c("upload-common-file", {
        attrs: {
          visible: _vm.uploadCommonFileDialog.visible,
          model: _vm.uploadCommonFileDialog.model
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.uploadCommonFileDialog, "visible", $event)
          }
        }
      }),
      _c("yazuishou-dialog", {
        attrs: { visible: _vm.yazuishouVisible },
        on: { submit: _vm.submitCallBack }
      }),
      _c("door-point-information", {
        attrs: {
          "v-if": _vm.addDoorDialog.visible,
          visible: _vm.addDoorDialog.visible,
          action: _vm.action,
          site: _vm.addDoorDialog.form
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.addDoorDialog, "visible", $event)
          },
          loadSites: _vm.loadSites
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }